import { connect } from "react-redux";
// import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
// import { Link, useLocation } from "react-router-dom";
// import { Tag, Eye, ThumbsUp, MessageSquare, ThumbsDown } from "react-feather";
import {
  // Row,
  // Col,
  Button,
  Modal,
  Spinner,
  // ModalBody,
  // ModalHeader,
  // ModalFooter,
} from "reactstrap";

// import Loader from "../../../Shared/Loader";
import {
  publishedToSwirl,
  updateVideoPageState,
  updateVideos,
} from "../VideoActions";
import DropboxPlayer from "../../../Shared/DropboxPlayer";
import { operations } from "../../../Shared/modules/videoDetail";
import { addDefaultSrc } from "../../../utilities";
import { useEffect, useState } from "react";
import CrossSVG from "../../../Shared/SVGs/Cross";
import { X } from "react-feather";

const SinglePublish = ({ singleVideo, onClose }) => {
  const dispatch = useDispatch();
  const [allPublished, setAllPublished] = useState(false);
  const [loading, setLoading] = useState(false);
  const { video } = singleVideo || {};

  const isPublished =
    video?.additional_data?.data?.published_to_swirl ===
    "Successfully updated published status";

  const videos = useSelector((state) => state.videos);
  useEffect(() => {
    const video = videos?.map((data) => data?.video);
    const publishedData = video?.map(
      (data) => data?.additional_data?.data?.published_to_swirl
    );
    const isPublishedSwirlArray = Array.isArray(publishedData);
    const allVideosPublished =
      isPublishedSwirlArray &&
      publishedData.every(
        (status) => status === "Successfully updated published status"
      );
    setAllPublished(allVideosPublished);
  }, [videos]);

  const publishVideosCheckList = useSelector(
    (state) => state.videoPageStates.publishVideosCheckList
  );
  const openSinglePublish = useSelector(
    (state) => state.videoPageStates.openSinglePublish
  );
  const handlePublish = () => {
    const params = {
      video_ids: video?._id ? [video?._id] : publishVideosCheckList,
      published: isPublished || allPublished ? false : true,
    };

    publishedToSwirl(params)
      .then((response) => {
        console.log(response.data);
        dispatch(updateVideoPageState({ showSinleSwirll: true }));
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleClose = () => {
    onClose();
    dispatch(
      updateVideoPageState({
        publishVideosCheckList: [],
      })
    );
  };
  const handleCall = () => {
    handlePublish();
    setLoading(true);
  };

  const handleApprove = () => {
    return handleClose;
  };
  const publishUnPublishIcon = (iconName) => (
    <img
      src={require(`@src/assets/images/vyrill/videos/${iconName}.png`).default}
      width={67}
    />
  );

  return (
    <Modal contentClassName="single-publish-swirll" isOpen={openSinglePublish}>
      <div className="cross-icon">
        <div onClick={handleApprove()} role="button">
          <X size={49} role="button" strokeWidth="1" />
        </div>
      </div>
      <div>
        {publishUnPublishIcon(
          isPublished || allPublished ? "unPublishedModal" : "publishedModal"
        )}
      </div>
      <div className="text">
        {isPublished || allPublished ? "Unpublish from" : "Publish to"}
      </div>
      <div className="swirl-box">
        <img
          src={
            require(`@src/assets/images/vyrill/videos/swirlLogo.png`).default
          }
          width={100}
          height={27}
        />
      </div>
      <div className="video-title">
        {publishVideosCheckList.length !== 0 ? (
          <>{publishVideosCheckList.length} videos selected</>
        ) : (
          <>Video: {video && video?.title ? video?.title : "No video title"}</>
        )}
      </div>
      <div className="d-flex justify-content-center">
        <Button
          className="video-process-btn"
          size="sm"
          color="primary"
          onClick={handleCall}
          disabled={loading}
        >
          {isPublished || allPublished ? "Unpublish" : "Publish"}
          {loading && (
            <Spinner
              size="sm"
              style={{ marginLeft: isPublished || allPublished ? "" : "7px" }}
            />
          )}
        </Button>
      </div>
    </Modal>
  );
};

SinglePublish.defaultProps = {};

SinglePublish.propTypes = {};

const mapStateToProps = ({ videoDetail, videos, videoData }) => ({
  status: videoDetail.status,
  videos,
  videoData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateVideoDetail: operations.updateVideoDetail,
      doUpdateVideos: updateVideos,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SinglePublish);
